export default [
  {
    path: '',
    name: 'change password',
    component: () => import('@/views/app/password/form-password.vue'),
    meta: { title: 'Ubah Password' },
  },
]
